import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react'
import { StyleSheet, Text, View } from 'react-native'
import { InitialInputVoiceSearch } from '../../../components/VoiceSearch/InitialInput/InitialInput'
import { FormatPond } from '../../../context/FreshWater/types'
import { corporateColor } from '../../../theme/colors'
import { Separator } from '../../../components/Separator'
import { SeaWaterContext } from '../../../context/SeaWater/SeaWaterContext'
import { InfoState } from '..'
import { ListItem } from './ListItem'
import { useTranslation } from 'react-i18next'
import { Items } from '../../../navigator/types'

interface Props {
  moduleId: number
  getValues: (values: InfoState) => void
  initValues?: Items[]
}

export const Cages = ({ moduleId, getValues, initValues }: Props) => {
  const { cages, states } = useContext(SeaWaterContext)
  const [pondsByRoom, setPondsByRooms] = useState<FormatPond[]>(() => cages[moduleId] ?? [])
  const [search, setSearch] = useState('')
  const { t } = useTranslation()

  const getSearchValue = useCallback((value: string) => setSearch(value), [])

  const filteredData = useMemo(
    () => pondsByRoom.filter((pond) => pond.name.toLowerCase().includes(search.toLowerCase())),
    [search, pondsByRoom],
  )

  const options = useMemo(
    () => states.map((option) => ({ id: option.id, name: t(option.name) })),
    [states, t],
  )

  const defaultOptionsMap = useMemo(
    () =>
      initValues?.map((item) => ({
        id: item.stateId,
        name: item.stateName,
        levelThreeId: item.levelThreeId,
      })),
    [initValues],
  )

  useEffect(() => {
    setPondsByRooms(cages[moduleId] ?? [])
  }, [moduleId, cages])

  return (
    <View style={{ flexGrow: 10 }}>
      <InitialInputVoiceSearch
        hasInput
        placeholder='Búsqueda de jaulas'
        getSearchValue={getSearchValue}
      />

      <View style={styles.header}>
        <View style={{ flex: 0.9 }}>
          <Text style={styles.headerText}>{t('JAULA')}</Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text style={styles.headerText}>{t('ESTADO ACTUAL')}</Text>
        </View>
        <View style={{ flex: 1 }}>
          <Text style={styles.headerText}>{t('NUEVO ESTADO')}</Text>
        </View>
      </View>

      <Separator />
      {filteredData.map((item, index) => (
        <ListItem
          item={item}
          isLastItem={index + 1 === filteredData.length}
          key={item.id}
          options={options}
          onChange={getValues}
          defaultOptions={defaultOptionsMap?.find((value) => value.levelThreeId === item.id)}
        />
      ))}
    </View>
  )
}

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10,
  },
  headerText: {
    color: corporateColor,
    fontWeight: 'bold',
  },
})
